import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinksComponent } from './links.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LinksComponent]
})
export class LinksModule { }



// WEBPACK FOOTER //
// /workspace/chess.arska.org/chess/src/app/links/links.module.ts